function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0-man{fill:#ffffff;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0-man",
  d: "M66.2,46.4C66.2,46.4,66.2,46.4,66.2,46.4c-0.2,3.7-0.5,8.3-1.4,14.6c-0.6,4.2-4.4,12.4-5.4,13.4 c-1.4,1.4-1.3,1.7-3.4,2c-0.5,0.1-2.1,0.9-2.7,0.7c-4-1.3-10.1-3.6-12.5-5c-1-0.6-1.9-1.2-2.6-1.7c-1.4-1-2.1-1.7-2.1-1.7 c-0.3,1.1-1.1,2.2-1.8,3c-0.1,0.1-0.2,0.3-0.3,0.4c0,0,0,0.1,0,0.1c0.6,1.1,0.4,2.8,0.1,3.8c-0.2,0.8-0.6,1.6-1.1,2.3 c0,0.6,0,1.3,0.1,1.9c0.2,1.3,0,2.5-0.4,3.8h-26c3-9.5-3.5-20.3-5.2-24.8c-1.5-4.4-1.6-5.8-1.4-9c0.3-3.9,1-8,2.8-11.5 c1.3-2.5,4.1-6.8,7.8-9.8c0.7-0.6,1.3-1.3,1.8-2c0,0,0,0,0,0c0.1-0.2,0.3-0.4,0.4-0.6c0.9-1.2,3-6.2,3.1-7.5c0-0.4,0-0.9-0.1-1.3 c-0.7-1.8-0.7-4.1-0.5-5.9c0.1-1.2,0.4-5,2.6-7.5c1.2-1.4,2.8-2.4,4.6-3c1.9-0.8,4.1-1,6.2-1c1.4,0,7.9,0.8,11.6,5 c1.1,1.2,2.4,2.7,2.5,4.4c0,0.4,0,0.9-0.2,1.3c-0.3,0.5-0.7,0.7-0.7,0.7c0-0.1-0.5,4.7-0.5,5c-0.1,0.4-0.3,0.8-0.5,1.1 c-0.2,0.3-0.7,0.7-0.8,1c0.4,1.2,0.3,1.9,0.3,2.1c0,0.4,0,0.8,0,1.2c0,0.5,0,0.9,0,1.4c0,0.8-0.4,1.4-1.4,1.3 c-0.3,0-0.6-0.1-0.9-0.1c0,0,0,0-0.1,0c0,0.2-0.1,0.3-0.2,0.4c-0.3,0.4-0.4,0.7-0.3,1.2c0,0.2-0.1,0.3-0.2,0.3 c-0.1,0-0.2,0.1-0.3,0.1c0,0.1,0.1,0.4,0.1,0.5c0,0.1,0,0.2-0.2,0.3c-0.1,0-0.5,0.4-0.6,0.5c-0.1,0.1-0.1,0.1-0.1,0.2 c-0.1,0.2,0.1,1.3-0.3,1.7c-0.2,0.2-0.6,0.5-1,0.8c-0.7,0.4-1.2,0.4-1.7,0.3c-0.9-0.1-3.9-1.7-4.5-2c-0.2,0.9-0.5,1.8-0.7,2.6 c-0.1,0.3-0.1,0.6-0.2,0.9c0,0.3,0,0.7-0.1,1c0.3,0.2,0.7,0.5,1,0.8c1,0.3,1.9,0.9,2.7,1.4c1.6,1,3,2.2,4.2,3.7 c0.9,1.1,1.9,2.7,2.4,4.4c0.4,0.2,4.3,1,7.5,4c4.1,3.9,4.8,7.7,5,10.3c0.2-4.3,3-7.5,5.4-10.9c0.1-0.2,1.7-2.7,1.9-2.9 c1.9-3.7,2.3-7.4,1.9-7.9c-0.5-0.5-1-2.3-1.1-2.8c-0.1-0.6-1.7-3.6-1.7-3.6s0.5-2.1,1.5-2.6l1.2,0.7c0,0-0.1-3.3,2.8-2.3 c2.9,1,5.4,1.9,5.8,2.9c0.4,1,0.3,4.2,0.3,4.2S66.6,40.2,66.2,46.4z"
});

function SvgMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68.4 84",
    style: {
      enableBackground: "new 0 0 68.4 84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("linearGradient", {
    id: "man",
    gradientUnits: "userSpaceOnUse",
    x1: -4.846661e-7,
    y1: 42,
    x2: 68.4037,
    y2: 42
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1EA2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E68FF"
    }
  })), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.3c69daba.svg";
export { ForwardRef as ReactComponent };